module.exports = __webpack_public_path__ + "img/jcssc.042d0333.jpg";